import React, { Component } from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import cx from 'classnames';
import s from './SkipVerificationModal.css';
import cs from '../../components/commonStyle.css';
import { Modal, Button } from 'react-bootstrap';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { closeSkipVerificationModal } from '../../actions/modalActions';
import alert_img from '../../../public/siteImages/alert.png';
import messages from '../../locale/messages';
import Link from '../../components/Link/Link';

class SkipVerificationModal extends Component {
    static propTypes = {
        onClose: PropTypes.func.isRequired,
        show: PropTypes.bool.isRequired,
    };

    render() {
        const { onClose, show } = this.props;
        const { formatMessage } = this.props.intl;

        return (
            <Modal show={show} animation={false} onHide={onClose} className="verificationModal">
                <Modal.Header closeButton></Modal.Header>
                <Modal.Body>
                    <div className={cx(s.verificationContent, cs.textAlignCenter)}>
                        <img src={alert_img} alt="Skip Verification" className={s.verificationImage} />
                        <h2 className={cx(s.titleText)}>Are you sure you want to continue without verifying?</h2>
                        <div className={s.buttonGroup}>
                            <Button className={cx(s.btnPrimary, s.button)} onClick={onClose}>Go Back & Verify</Button>
                            <Link to={"/dashboard"} className={cx(s.btnSecondary, s.button)}>Skip Verification</Link>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        );
    }
}

const mapState = state => ({
    skipVerificationModal: state.modalStatus.isSkipVerificationModalOpen,
});

const mapDispatch = {
    closeSkipVerificationModal,
};

export default injectIntl(withStyles(s, cs)(connect(mapState, mapDispatch)(SkipVerificationModal))); 